export default {"src":"/_next/static/media/close-icon.001c4333.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};